// extracted by mini-css-extract-plugin
export default {"advertDetailServiceList":"c-n_ge","advertDetailServiceList__header":"c-n_gf","advertDetailServiceList__list":"c-n_gg"};